import { CombinedGraphQLErrors } from '@apollo/client'
import { isPresent } from '@mbfab/shared'

// ミューテーション失敗時に、ユーザーへ出す文言を決める（v1 apps/frontend/client/src/lib/userFacingErrorMessage.ts を移植）。
//
// **サーバーのエラーメッセージをそのまま画面に出してよい**のは、
// `apps/backend/web/graphql/formatError.ts` が「汎用エラークラス（ValidationError / NotFoundError 等）の
// メッセージだけを通し、それ以外は一律で『エラーが発生しました。』に潰す」ことを保証しているため
// （docs/develop/error_handling.md）。内部エラーの詳細がクライアントへ届くことはない。
//
// 逆に GraphQL エラー以外（ネットワーク断・プロトコルエラー等）はユーザー向けの文言ではないので、
// 呼び出し側が用意した fallbackMessage（「〜に失敗しました」）を使う。
export function userFacingErrorMessage(error: unknown, fallbackMessage: string): string {
  if (!CombinedGraphQLErrors.is(error)) {
    return fallbackMessage
  }
  // 複数エラーが返る場合は全て見せる（どれか1つだけ出すと、直すべき点を取りこぼす）
  const messages = error.errors.map((graphQLError) => graphQLError.message).filter(isPresent)
  return messages.length === 0 ? fallbackMessage : messages.join('\n')
}
